/**
 * A list search, in the browser: every word of the query is in one of the fields, with no regard
 * to case or accents. "pertamina geo" finds "PT Pertamina Geothermal". An empty query matches.
 *
 * For lists the console already holds in full (a few hundred rows at most), where a request per
 * key press would only add a wait.
 */
export function matchesQuery(
  fields: readonly (string | null | undefined)[],
  query: string,
): boolean {
  const words = fold(query)
    .split(/\s+/)
    .filter((word) => word !== '')
  if (words.length === 0) return true
  const text = fold(fields.filter((field) => typeof field === 'string').join(' '))
  return words.every((word) => text.includes(word))
}

/** Lower case, with accents removed: "Équipe" and "equipe" are the same word to a reader. */
function fold(value: string): string {
  return value
    .normalize('NFD')
    .replaceAll(/\p{Diacritic}/gu, '')
    .toLowerCase()
}
